import { useEffect, useState } from 'react'

import { useHistory } from 'react-router-dom'
import { Controller, useForm } from 'react-hook-form'
import { isEmpty } from 'lodash'
import {
  Box,
  Button,
  FormControlLabel,
  Grid,
  Paper,
  Radio,
  RadioGroup,
} from '@material-ui/core'

import { CompanyTypeAndSeachInput, LoadingFeedback } from 'components'

import { ProcessSelect, DepartmentSelect } from '../../../components'

import * as service from 'service'

import { routes } from 'Routes'

import schema from './schema'
import helpers from 'helpers'

import { useSnackbar, useTransferList } from 'hooks'

const RemoveForm = () => {
  const SOURCE_TYPE_PROCESS = 'process'
  const SOURCE_TYPE_DEPARTMENT = 'department'
  const SOURCE_TYPE_COMPANY = 'company'

  const [loading, setLoading] = useState(false)
  const snackbar = useSnackbar()
  const history = useHistory()
  const { handleSubmit, control, errors, watch, setValue } = useForm({
    validationSchema: schema,
    defaultValues: {
      sourceType: SOURCE_TYPE_COMPANY,
    },
  })

  const sourceType = watch('sourceType')
  const originCompany = watch('originCompany')

  const isProcessSelect = sourceType === SOURCE_TYPE_PROCESS
  const isDepartmentSelect = sourceType === SOURCE_TYPE_DEPARTMENT

  const { right } = useTransferList()

  const handleProcess = () => {
    history.push(routes.dataProcess.all)
  }

  const onSubmit = async (data) => {
    setLoading(true)
    const payload = {
      ...(data?.sourceType === SOURCE_TYPE_COMPANY && {
        all_processes: true,
        companyIds: data?.sourceIds,
      }),
      ...(data?.sourceType === SOURCE_TYPE_DEPARTMENT && {
        departmentIds: data?.sourceIds,
      }),
      ...(data?.sourceType === SOURCE_TYPE_PROCESS && {
        ids: data?.sourceIds,
      }),
    }
    try {
      await service.dponet.dataProcesses.softDeleteMany(payload)
      snackbar.open({
        message: 'Processos deletados com sucesso!',
        variant: 'success',
      })
      handleProcess()
    } catch (e) {
      snackbar.open({
        message: helpers.formatters.errorMessage(e, false),
        variant: 'error',
      })
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    if (!!originCompany && sourceType === SOURCE_TYPE_COMPANY) {
      setValue('sourceIds', [originCompany?.id])
    } else {
      if (!isEmpty(right)) {
        setValue(
          'sourceIds',
          right?.map((source) => source?.id),
        )
      } else {
        setValue('sourceIds', undefined)
      }
    }
  }, [right, sourceType, originCompany])

  return (
    <form id="form-remove-data-process" onSubmit={handleSubmit(onSubmit)}>
      <LoadingFeedback open={loading} />
      <Paper component={Box} p={2}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <CompanyTypeAndSeachInput
              control={control}
              errors={errors}
              label="Empresa"
              fieldName="originCompany"
            />
          </Grid>
          <Grid item xs={12}>
            <Controller
              as={
                <RadioGroup row>
                  <FormControlLabel
                    value={SOURCE_TYPE_COMPANY}
                    control={<Radio />}
                    label="Todos os processos"
                  />
                  <FormControlLabel
                    value={SOURCE_TYPE_DEPARTMENT}
                    control={<Radio />}
                    label="Por departamento"
                  />
                  <FormControlLabel
                    value={SOURCE_TYPE_PROCESS}
                    control={<Radio />}
                    label="Escolher processos"
                  />
                </RadioGroup>
              }
              name="sourceType"
              control={control}
            />
          </Grid>
          <ProcessSelect
            companyId={originCompany?.id}
            show={isProcessSelect}
            isToExclude={true}
          />
          <DepartmentSelect
            companyId={originCompany?.id}
            show={isDepartmentSelect}
          />
          <Controller as={<></>} name="sourceIds" control={control} />
        </Grid>
      </Paper>
      <Box width="100%" display="flex" py={2} gridGap={4}>
        <Button disabled={loading} variant="outlined" onClick={handleProcess}>
          Voltar
        </Button>
        <Button
          disabled={loading}
          type="submit"
          variant="contained"
          color="primary"
        >
          Deletar
        </Button>
      </Box>
    </form>
  )
}

export default RemoveForm
